<template>
  <div class="searchResult">
    <!-- <topTitle title="收藏商品"></topTitle> -->
    <div class="goodListHead">
      <div class="headLeft" @click="$router.go(-1)">
        <img src="../../assets/localImage/return.png" alt />
      </div>

      <form action="/">
        <div class="centerSearch">
          <van-search v-model="value" shape="round" placeholder="搜索商品" @search="onSearch" />
        </div>
      </form>
    </div>

    <van-tabs v-model="active" swipeable @change="tabChange">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          offset="10"
          :immediate-check="false"
          @load="onLoad()"
        >
      <van-tab title="商品">
        <div class="listTools">
          <div @click="sortList(0)">
            <span :class="sortActivity==0?'on':''">综合</span>
          </div>
          <div  @click="sortList(1)">
            <span :class="sortActivity==1?'on':''">销量</span>
          </div>
          <div  @click="sortList(2)">
            <span :class="sortActivity==2?'on':''">价格</span>
            <img :src="horl ? himg : limg" alt />
          </div>
          <div @click="showFilters()">
            <span  :class="sortActivity==3?'on':''">筛选</span>
            <img src="../../assets/img/icon/filters.png" alt />
          </div>
          <div class="headRight" @click="togglePermu">
            <img v-if=" permutation == 'rect' " src="../../assets/img/icon/rectShow.png" alt />
            <img
              v-if=" permutation ==  'vertical' "
              src="../../assets/img/icon/verticalShow.png"
              alt
            />
          </div>
        </div>
        
          <div v-if=" permutation == 'vertical' " class="goodsList">
            <listOfItems :data="goosList"></listOfItems>
          </div>
          <div v-if=" permutation == 'rect' " class="goodsList">
            <verticalItemList :data="goosList"></verticalItemList>
          </div>
      </van-tab>

      <van-tab title="店铺">
        <div class="listBox">
          <!-- <van-list
            v-model="loading2"
            :finished="finished2"
            finished-text="没有更多了"
            offset="5"
            :immediate-check="false"
            @load="onLoad2()"
          > -->
            <div class="listInfo" v-for="(obj,i) in shopsList" :key="i">
              <div class="infoTop clearfix">
                <div class="leftImg">
                  <img :src="obj.shop_logo ? obj.shop_logo : $store.state.defaultdp" />
                </div>
                <div class="rightText">
                  <h5>
                    {{obj.shop_name}}
                    <img src="../../assets/img/icon/dayLottery.png" alt="抽奖" />
                  </h5>
                  <p class="address">{{obj.shop_province}} . {{obj.shop_city}}</p>
                  <div class="shopScore">
                    <div class="scoreKind">
                      <img src="../../assets/img/icon/describe.png" />
                      <span>宝贝描述</span>
                      <p>{{obj.shop_description_credit}}</p>
                    </div>
                    <div class="scoreKind">
                      <img src="../../assets/img/icon/attitude.png" />
                      <span>服务态度</span>
                      <p>{{obj.shop_service_credit}}</p>
                    </div>
                    <div class="scoreKind">
                      <img src="../../assets/img/icon/speed.png" />
                      <span>发货速度</span>
                      <p>{{obj.shop_delivery_credit}}</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="shopBtn">
                <van-button class="goodsBtn" color="#FF5507" @click="toshaoplist(obj)" plain>全部商品</van-button>
                <van-button
                  class="goshopBtn"
                  color="linear-gradient(to right, #FE8702, #FF1000)"
                  @click="todp(obj)"
                >进入店铺</van-button>
              </div>
            </div>
          <!-- </van-list> -->
        </div>
      </van-tab>
    </van-list>

    </van-tabs>


    <van-action-sheet v-model="showFilter">
		<div class="filterContent">
			<div class="topIcon"></div>
			<div class="priceRange">
				<h4>价格区间</h4>
					<van-field v-model="lowPrice" name="最低价" placeholder="最低价" />
					<span>-</span>
					<van-field v-model="highPrice" name="最高价" placeholder="最高价" />
			</div>
			<div class="brand">
				<h4>品牌</h4>
				<div class="brandList">
					<span :class="objindex == item.brand_id?'active':''" v-for="(item,index) in sxpp" :key="index" @click="xzpp(item)">{{item.name}}</span>
				</div>
			</div>
			<div class="dayLuckDraw">
				<h4>天天抽奖</h4>
				<div class="LuckDraw" @click="sfsxcj()" >
					<span :class="sxcj ? 'active':''">抽奖</span>
				</div>
			</div>
			<div class="filterBtn" >
				<button class="resetBtn" @click="chongzhi()" >重置</button>
				<button class="saveBtn" @click="qieren()">确定</button>
			</div>
		</div>
	</van-action-sheet>
  </div>
</template>

<script>
import topTitle from "../../components/topTitle.vue";
import listOfItems from "../../components/listOfItems.vue";
import verticalItemList from "../../components/verticalItemList.vue";

// import { Swipe, SwipeItem, Tab, Tabs, Dialog} from 'vant';
export default {
  name: "searchResult",
  data() {
    return {
      active: 0,
      checked: true,
      edit: false,
      value: this.$route.query.text,
      permutation: "vertical",
      goosList: [],
      shopsList: [],
      page_no: 1,
      page_size: 10,
      loading: true,
      finished: false,

      showFilter: false,
      lowPrice:"",
      highPrice:"",
      sortActivity:0,
      sxpp:[],
      objindex:'',
      sortType:'',
      sxcj:false,
      horl:true,
      toggleBuynum:true,
      himg:require('../../assets/img/icon/higher.png'),
      limg:require('../../assets/img/icon/low.png')
    };
  },
  components: {
    topTitle,
    listOfItems,
    verticalItemList
  },
  created() {
    console.log(this.value);
    this.getList();
    //获取筛选品牌
    this.getsxData();
  },
  methods: {
    //是否筛选抽奖
    sfsxcj(){
      this.sxcj = !this.sxcj;
    },
    //重置
    chongzhi(){
       this.objindex = ''
    },
    xzpp(obj){
      if(this.objindex==obj.brand_id){
        this.objindex = '';
      }else{
        this.objindex = obj.brand_id;
      }
    },
    sortList(type){
      this.goosList = [];
      this.page_no = 1;
      this.sortActivity = type;

      this.loading = true;
      this.finished = false;
      if(type == 1){
        this.toggleBuynum = !this.toggleBuynum;
			if(this.toggleBuynum){
         		this.sortType = 'buynum_asc'
			}else{
			this.sortType = 'buynum_desc'
			}
      }else if(type == 2){
        this.horl = !this.horl;
        if(this.horl){
          this.sortType = 'price_asc'
        }else{
          this.sortType = 'price_desc'
        }
      }else if(type == 0){
        this.sortType = ''
      }
      this.getList()
    },
    showFilters() {
      // this.sortActivity = 3;
		  this.showFilter = true
    },
    qieren(){
      this.sortActivity = 3;
      this.goosList = [];
      this.showFilter = false;
      this.getList()
      
    },

    getsxData(){
      this.getRequest(`goods/search/brands`,{page_no:1,page_size:10000000}).then(res => {
        // this.hotList = res.data.data;
        if (res.data.code == 1) {
         this.sxpp = []
        } else {
          // res.data.data.forEach(element => {
          //   element.show = false;
          // });
         this.sxpp = res.data.data
        }
      });
    },
    onSearch() {
      this.page_no = 1;
      if (this.active == 0) {
        this.getList();
      } else {
        this.dpList();
      }
    },

    onLoad() {
      this.page_no = this.page_no + 1;
      if (this.active == 0) {
        this.getList();
      } else {
        this.dpList();
      }
    },

    tabChange(index, title) {
      this.page_no = 1;
      this.goosList = [];
      this.shopsList = [];
      if (index == 0) {
        this.getList();
      } else {
        this.dpList();
      }
    },
    getList() {
      let param = {
        page_no: this.page_no,
        page_size: this.page_size,
        keyword: this.value,
        isRaffle:this.sxcj?1:'',
        priceSmall:this.lowPrice,
        priceBig:this.highPrice,
        sort:this.sortType,
        brand:this.objindex,
      };
      this.getRequest(`goods/search/searchGoods`, param).then(res => {
        // this.hotList = res.data.data;
        if (res.data.code == 1) {
          this.goosList = [];
          this.loading = false;
          this.finished = true;
        } else {
          this.loading = false;
          // 数据全部加载完成
          if (res.data.data.length < 10) {
            this.finished = true;
          }
          this.goosList = this.goosList.concat(res.data.data);
        }
      });
    },
    //店铺列表
    dpList() {
      this.getRequest(`shops/list`, {
        page_no: this.page_no,
        page_size: this.page_size,
        name: this.value
      }).then(res => {
        // this.hotList = res.data.data;
        if (res.data.code == 1) {
          this.shopsList = [];
          this.loading = false;
          this.finished = true;
        } else {
          // 数据全部加载完成
          this.loading = false;
          if (res.data.data.length < 10) {
            this.finished = true;
          }
          this.shopsList = this.shopsList.concat(res.data.data.data);
        }
      });
      console.log(this.shopsList);
    },
    toshaoplist(obj) {
      this.$router.push({ path: "/goodsList" ,query: { shop_id: obj.shop_id } });
    },
    todp(obj) {
      this.$router.push({
        path: "/shopIndex",
        query: { shop_id: obj.shop_id }
      });
    },
    togglePermu() {
      if (this.permutation == "vertical") {
        this.permutation = "rect";
      } else {
        this.permutation = "vertical";
      }
    },
    topHandle() {
      this.edit = !this.edit;
    }
  }
};
</script>


<style scoped lang='less'>
.searchResult {
  .filterContent {
  	padding: 10px 0px;

  	.topIcon {
  		width: 60px;
  		height: 12px;
  		background-color: #B9B9B9;
  		border-radius: 8px;
  		margin: 0 auto;
  	}
  
  	.priceRange {
  		text-align: center;
  		padding: 0 20px;
  		border-bottom: solid 4px #F2F2F2;
  
  		h4 {
  			text-align: left;
  			margin: 25px 0;
  		}
  
  		/deep/ .van-cell {
  			width: 40%;
  			background: rgba(242, 242, 242, 1);
  			border-radius: 30px;
  			padding: 5px;
  			display: inline-block;
  			text-align: center;
  
  			input {
  				text-align: center;
  			}
  		}
  
  		span {
  			display: inline-block;
  			margin-bottom: 30px;
  			margin: 0 20px;
  			height: 80px;
  			vertical-align: middle;
  		}
  	}
  
  	.brand {
  		padding: 20px;
  		background-color: #fff;
  
  		h4 {
  			color: #040404;
  			font-size: 24px;
  			margin-bottom: 26px;
  		}
  
  		.brandList {
        max-height: 400px;
        overflow-y: scroll;
        display: flex;
        flex-wrap: wrap;
  			span {
  				background: rgba(242, 242, 242, 1);
  				border-radius: 27px;
          min-width: 140px;
          padding: 0 20px;
  				height: 54px;
  				text-align: center;
  				line-height: 54px;
  				margin-right: 14px;
  				margin-bottom: 30px;
  			}
  			span.active {
  				border: solid 2px #F33925;
  				color: #FE5E15;
  			}
  		}
  	}
  	.dayLuckDraw {
  		padding: 20px;
  		background-color: #fff;
  		border-bottom: solid 4px #F2F2F2;
  		h4 {
  			color: #040404;
  			font-size: 24px;
  			margin-bottom: 26px;
  		}
  		.LuckDraw{
  			span {
  				display: inline-block;
  				background: rgba(242, 242, 242, 1);
  				border-radius: 27px;
  				width: 167px;
  				height: 54px;
  				text-align: center;
  				line-height: 54px;
  				margin-right: 14px;
  				margin-bottom: 30px;
  			}
  			span.active {
  				border: solid 2px #F33925;
  				color: #FE5E15;
  			}
  		}
  	}
  	.filterBtn{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 20px 0;
      box-sizing: border-box;
  		.resetBtn{
  			width:294px;
  			height:67px;
  			background:rgba(255,255,255,1);
  			border-radius:34px;
  			border:1px solid rgba(148,148,148,1);
  			color: #343434;
  			font-size: 24px;
  			margin-right: 26px;
  		}
  		.saveBtn{
  			width:294px;
  			height:67px;
  			background: linear-gradient(to right,#F2170C,#F24C0B);
  			color: #fff;
  			font-size: 24px;
  			border-radius:34px;
  			
  		}
  	}
  }
  /deep/ .van-action-sheet{height: auto;}
  /deep/.van-tabs {
    .van-tab--active {
      color: #ff1919;
    }
    .van-tabs__wrap {
      position: fixed;
      top: 89px;
      width: 100%;
      left: 0;
      z-index: 99;
    }
    .van-tab--active .van-tab__text {
      font-size: 30px;
    }
    .van-tabs__nav .van-tab__text {
      font-size: 28px;
      line-height: 90px;
      font-family: pingFangSC-Medium;
    }
    .van-tabs__nav .van-tabs__line {
      width: 48px !important;
      height: 6px !important;
      background: linear-gradient(to right, #f00f00, #ff9176, #ffddd4);
    }
    .van-tabs__content {
      padding-top: 176px;
    }
  }
  /deep/ [class*="van-hairline"]::after {
    border: none;
  }
  .goodListHead {
    padding: 0 36px;
    width: 100%;
    position: fixed;
    z-index: 100;
    top: 0;
    left: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #ffffff;
    height: 89px;
    .headLeft {
      width: 20px;
      height: 36px;
    }
    .centerSearch {
      width: 635px;
      height: 68px;
      .van-search {
        padding: 0;
      }
    }
  }
  .listTools {
    display: flex;
    justify-content: space-around;
    background-color: #fff;
    position: fixed;
    top: 176px;
    left: 0;
    width: 100%;
    z-index: 99;
    // padding: 20px 0;
    height: 76px;
    align-items: center;
    border-top: 1px solid #ebedf0;
    // padding-left: 50px;
    // padding-right: 20px;
    .headRight {
      img {
        width: 28px;
        height: 24px;
        margin-left: 0;
      }
    }
    div {
      // width: 25%;
      text-align: center;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      span {
        font-size: 28px;
        color: #333333;
      }
      span.on {
        color: #ff1919;
      }
      img {
        display: inline-block;
        width: 16px;
        height: 20px;
        margin-left: 5px;
      }
    }
  }
  .goodsList {
    padding-top: 80px;
  }
  // .goodsList {
  //   padding: 20px 18px;
  //   .item {
  //     width: 714px;
  //     height: 302px;
  //     background: rgba(255, 255, 255, 1);
  //     border-radius: 8px;
  //     padding: 31px 26px;
  //     display: flex;
  //     flex-direction: column;
  //     margin-bottom: 20px;

  //     h2 {
  //       font-size: 26px;
  //       font-weight: 500;
  //       color: rgba(51, 51, 51, 1);
  //       img {
  //         width: 12px;
  //         height: 20px;
  //         display: inline-block;
  //         margin-left: 10px;
  //       }
  //     }
  //     > div {
  //       margin-top: 29px;
  //       display: flex;
  //       justify-content: space-between;

  //       .img {
  //         width: 180px;
  //         height: 180px;
  //         margin-right: 30px;
  //       }
  //       .name {
  //         flex: 1;
  //         padding-bottom: 24px;
  //         display: flex;
  //         flex-direction: column;
  //         justify-content: space-between;
  //         p {
  //           font-size: 26px;
  //           font-family: PingFangSC-Regular, PingFang SC;
  //           font-weight: 400;
  //           color: rgba(51, 51, 51, 1);
  //           line-height: 37px;
  //         }
  //         span {
  //           font-size: 22px;
  //           font-family: AlibabaPuHuiTiM;
  //           color: rgba(255, 25, 25, 1);
  //         }
  //       }
  //     }
  //   }
  // }
  .listBox {
    padding: 20px 18px;
    padding-bottom: 0px;
    .listInfo {
      background-color: #fff;
      padding: 30px;
      margin-bottom: 20px;

      .leftImg {
        float: left;
        width: 20%;

        img {
          width: 104px;
          height: 104px;
        }
      }

      .rightText {
        float: right;
        width: 75%;
        margin-left: 30px;
        text-align: left;

        h5 {
          font-size: 28px;
          font-weight: 600;

          img {
            display: inline-block;
            width: 66px;
            height: 30px;
            vertical-align: middle;
          }
        }

        .address {
          font-size: 26px;
          color: #333;
          margin: 10px 0 18px 0;
        }

        .shopScore {
          display: flex;
          justify-content: space-between;
          width: 100%;

          .scoreKind {
            img {
              width: 26px;
              height: 26px;
              display: inline-block;
              vertical-align: middle;
              margin-right: 9px;
            }

            span {
              font-size: 24px;
              color: #9a9a9a;
            }

            p {
              font-size: 24px;
              color: #000000;
              text-align: center;
              margin-top: 10px;
              font-weight: 600;
            }
          }
        }
      }

      .shopBtn {
        .goodsBtn,
        .goshopBtn {
          border-radius: 25px;
          width: 130px;
          height: 50px;
          text-align: center;
          line-height: 50px;
          padding: 0;
          font-size: 22px;
          margin: 20px 40px;
        }
      }
    }
  }
}
</style>


